var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarbage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.84,30.098h-4.563h-7.62v-4.307c0-1.104-0.896-2-2-2H41.344c-1.104,0-2,0.896-2,2v4.307h-7.62H27.16 c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.707l2.699,36.26c0.078,1.044,0.948,1.852,1.995,1.852h26.879c1.047,0,1.917-0.808,1.994-1.852 l2.699-36.26h2.707c1.104,0,2-0.896,2-2S69.944,30.098,68.84,30.098z M43.344,27.791h9.312v2.307h-9.312V27.791z M59.583,68.209 H36.417l-2.539-34.111h7.466h13.312h7.466L59.583,68.209z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.606,40.366c-1.104,0-2,0.896-2,2v17.576c0,1.104,0.896,2,2,2s2-0.896,2-2V42.366 C45.606,41.261,44.71,40.366,43.606,40.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.394,40.366c-1.104,0-2,0.896-2,2v17.576c0,1.104,0.896,2,2,2s2-0.896,2-2V42.366 C54.394,41.261,53.498,40.366,52.394,40.366z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/garbage.3adc6d5801d819cdb625e10903547770.svg";
export { ForwardRef as ReactComponent };